export const helpRoutes = {
    home: {
        url: {
            get: () => 'https://help.pendwa.org',
        },
    },
    crosswordComplete: {
        url: {
            get: () => 'https://help.pendwa.org/en/articles/5965924-when-is-a-crossword-complete',
        },
    },
    crosswordShortcuts: {
        url: {
            get: () => 'https://help.pendwa.org/en/articles/5965921-crossword-navigation-shortcuts',
        },
    },
    coins: {
        url: {
            get: () => 'https://help.pendwa.org/en/articles/5965917-what-are-coins',
        },
    },
};
//# sourceMappingURL=help.js.map